import { render } from "./Virtual.vue?vue&type=template&id=26aab968"
import script from "./Virtual.vue?vue&type=script&lang=js"
export * from "./Virtual.vue?vue&type=script&lang=js"
script.render = render

export default script